<template>
<v-row>
  <v-col>
    <v-card height="50" class="d-flex align-center" color="transparent" elevation="0">
      <a href="https://docs.google.com/forms/d/e/1FAIpQLScxsLtLg0BXdz3f1yywU9WNG6kpfOy2w_LEHSda2MW1zG_ZCQ/viewform">
        <v-btn color="primary" elevation="3">
          お問合せフォーム
        </v-btn>
      </a>
      <v-divider class="mx-2"></v-divider>
      <v-card-text>お電話:<b>0120-311-054</b> または <b>090-3144-6847</b></v-card-text>
    </v-card>
  </v-col>
</v-row>
</template>

<script>
export default {
  data: () => ({
  }),
}
</script>

<style>
</style>
